<h1>Welcome on EUFIC's Nexus management system</h1>

<div class="welcome">
    <h1>Intro</h1>
    <div>
        <p>Nexus is EUFIC's internal database in which we collect contacts and organisations that are part of our
            network.</p>

        <p>It contains useful information (e.g., stakeholder type, topics of interest, relevant projects and
            initiatives
            associated to them, etc.) for EUFICers who are looking for people or organisations who are involved, or
            to
            get
            involved, in our activities.</p>

        <p>Learn how to use Nexus and how it can support your work <a
                href="https://eufic.slite.com/api/s/eXZSvcA2tPJ4Ia/Nexus-v-1">on our knowledge base</a>.</p>
    </div>
</div>

<div>
    <app-dashboard />
</div>
<div class="welcome-container">

    @if (signedIn) {
    <p>You are signed in as {{ username }} with role ({{userroles}}).</p>
    } @else {
    <p>Please sign in with your Microsoft account to access the dashboard.</p>

    <button mat-raised-button color="primary" (click)="login()">
        Sign in with Microsoft
    </button>
    }

</div>